module.exports = __webpack_public_path__ + "img/teal_logo_bg.40a20386.jpg";